// "Production" enabled environment

export const environment = {
    production: true,
    appConfig: 'appconfig.production.json',
};
